<div class="muc-bottom-panel">{{{o.__("You're not allowed to send messages in this room")}}}</div>
